import configureStore from '../redux/store';
import history from './history';

const store = configureStore(history, {});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
